const o = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M23.25 7.311 12.53 18.03a.749.749 0 0 1-1.06 0L.75 7.311"></path></svg>';
export {
  o as default
};
